import { useMemo } from "react";

import Grid from "@mui/material/Grid";

import { formatAwsDateString } from "@covertree/utils";
import { LoadingOrValue } from "@covertree/ui";
import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";

import { mapPaymentSchedule } from "@utils/mapPaymentSchedule";
import { mapProductTypeName } from "../utils/mapProductTypeName";
import { PolicyDetailsContentProps } from "../../../types";

export function PolicyDetails({ policy, loading }: PolicyDetailsContentProps) {
  const isBookConversion = useMemo(
    () => !!policy?.bookConversion?.previousPolicyId,
    [policy]
  );
  return (
    <>
      <Grid item xs={12}>
        <DisplayPropertiesCard
          properties={[
            {
              label: "Policy type",
              value: (
                <LoadingOrValue
                  loading={!policy && loading}
                  value={mapProductTypeName(
                    policy?.productTypeName,
                    isBookConversion
                  )}
                  height={24}
                  width={121}
                />
              ),
              showAsTypography: true,
            },
            {
              label: "Plan",
              value: (
                <LoadingOrValue
                  loading={!policy && loading}
                  value={policy?.units[0]?.selectedPlan ?? "Unknown"}
                  height={24}
                  width={121}
                />
              ),
              showAsTypography: true,
            },
            {
              label: "Payment term",
              value: (
                <LoadingOrValue
                  loading={!policy && loading}
                  value={mapPaymentSchedule(policy?.paymentScheduleName)}
                  height={24}
                  width={121}
                />
              ),
              showAsTypography: true,
            },
          ]}
        />
      </Grid>

      <Grid item xs={12}>
        <DisplayPropertiesCard
          properties={[
            {
              label: "Issue date",
              value: (
                <LoadingOrValue
                  loading={!policy && loading}
                  value={formatAwsDateString(policy?.issuedDate)}
                  height={24}
                  width={121}
                />
              ),
              showAsTypography: true,
            },
            {
              label: "Start date",
              value: (
                <LoadingOrValue
                  loading={!policy && loading}
                  value={formatAwsDateString(policy?.startDate)}
                  height={24}
                  width={121}
                />
              ),
              showAsTypography: true,
            },
            {
              label: "Expiration date",
              value: (
                <LoadingOrValue
                  loading={!policy && loading}
                  value={formatAwsDateString(policy?.endDate)}
                  height={24}
                  width={121}
                />
              ),
              showAsTypography: true,
            },
          ]}
        />
      </Grid>

      {isBookConversion && (
        <Grid item xs={12}>
          <DisplayPropertiesCard
            properties={[
              {
                label: "Previous policy number",
                value: policy?.bookConversion?.previousPolicyId ?? "Unknown",
                gridSize: 6,
              },
              {
                label: "Book conversion source",
                value: policy?.bookConversion?.source ?? "Unknown",
                gridSize: 6,
              },
            ]}
          />
        </Grid>
      )}
    </>
  );
}
